import { Container, Image, Button,Row,Col } from 'react-bootstrap';
import {
    DonateToUsBanner,
    DonateToUsWrapper,
    DonateToUsText,
    DonateToUsImage,
    Title,
    DonateToUsContent,
    TopImage,
    BottomImage,
    MainImage,
    ImpactNumbers,
    OurImpactNumbers,
    OurImpactTitle,
    OurNumber,
    NumberTitle,
    SupportMission,
    SupportMissionContent,
    SupportMissionText,
    SupportImage,
    ClientQuotesContent,
    QuotesIcon,
    ClientText,
    ClientName,
    TaxDeductible,
    TaxDeductibleImage,
    TaxDeductibleText,
    TaxDeductibleContent,
    DeductibleText,
} from './donateToUsStyle';
import AnnieSprat from '../../../assests/images/annie-spratt.webp';
import PexelMatheu from '../../../assests/images/pexels-matheus.webp';
import LarmRmah from '../../../assests/images/larm-rmah.webp';
import DonationDifference from '../../../components/common/donationDifference';
import SupportMissionImage from '../../../assests/images/mission.webp';
import Quotes from '../../../assests/images/quotes.svg';
import ClientQuotesImage from '../../../assests/images/clientdonate.webp';
import TopWards  from '../../../assests/images/trbadge.webp';
import { useNavigate } from 'react-router-dom';
import { MESSAGE } from '../../../utils/message';
import { donationNumbersHandler } from '../../../redux/slices/donationCamp/donationNumbers-slice';
import { useDispatch,useSelector } from 'react-redux';
import { useEffect } from 'react';
import { donationDifferenceHandler } from '../../../redux/slices/donationCamp/donationMakeDifference-slice';
import MetaComponent from '../../../components/common/metaComponent';

const DonateToUs = () => {
    const navigate = useNavigate();
    const dispatch:any = useDispatch();
    const donationNumbers = useSelector((state:any) => state?.donationNumbers?.data);
    const donationDifferenceData  = useSelector((state:any) => state?.donationMakeDifference?.data);
    useEffect(() => {
      dispatch(donationNumbersHandler())
      dispatch(donationDifferenceHandler())
    },[])
    return (
        <>
        <MetaComponent 
            keywords=""
            description=""
            ogTitle="Donate to Us | GreatNonprofits"
            ogDescription=""
            ogUrl="https://www.about.greatnonprofits.org/donate-to-us"
            ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
        />
        <>
            <DonateToUsBanner>
                <Container className="cont-w">
                    <DonateToUsWrapper>
                        <DonateToUsText>
                            <Title>Empower Nonprofits, Empower Communities </Title>
                            <DonateToUsContent>Join us in supporting nonprofits to enhance trust, amplify impact & foster excellence in the nonprofit sector.</DonateToUsContent>
                            <Button className="btn-outline-success-blue" onClick={() => {typeof localStorage !=="undefined"&&localStorage.removeItem("search");navigate("/organizations/browse")}}> Donate to GreatNonprofits</Button>
                        </DonateToUsText>
                        <DonateToUsImage>
                            <TopImage><Image src={LarmRmah} /></TopImage>
                            <MainImage><Image src={AnnieSprat} /></MainImage>
                            <BottomImage><Image src={PexelMatheu} /></BottomImage>
                      </DonateToUsImage>
                    </DonateToUsWrapper>
                </Container>
          </DonateToUsBanner>

           <ImpactNumbers>
             <Container className="cont-w">
                 <OurImpactNumbers>
                        <OurImpactTitle>{MESSAGE.donateNumberTitle}</OurImpactTitle>
                        <Row>
                            {donationNumbers?.data?.map((donation:any, index:number) => (
                                <Col md={3} sm={6} key={index+1}>
                                    <OurNumber>{donation.numbers}</OurNumber>
                                    <NumberTitle>{donation.category}</NumberTitle>
                                </Col>
                            ))}
                        </Row>
                 </OurImpactNumbers>
                    <DonationDifference data={donationDifferenceData?.data}/>

                    <SupportMission>
                        <SupportMissionContent>
                            <OurImpactTitle>{MESSAGE.supportMission}</OurImpactTitle>
                            <SupportMissionText>{MESSAGE.supportMissionDescription}</SupportMissionText>
                            <Button className="btn-outline-success-blue" onClick={() => {typeof localStorage !=="undefined"&&localStorage.removeItem("search");navigate("/organizations/browse")}}> Donate to GreatNonprofits</Button>
                        </SupportMissionContent>

                        <SupportImage>
                             <Image src={SupportMissionImage}/>
                        </SupportImage>

                    </SupportMission>

                    <SupportMission>
                        <SupportImage>
                             <Image src={ClientQuotesImage}/>
                        </SupportImage>
                        <ClientQuotesContent>
                            <QuotesIcon><Image src={Quotes} /></QuotesIcon>
                            <ClientText>{MESSAGE.donationUsQuote}&#10084;</ClientText>
                            <ClientName>Bill Gates, Microsoft</ClientName>
                        </ClientQuotesContent>
                    </SupportMission>
                    <TaxDeductible>
                        <OurImpactTitle>{MESSAGE.donationBadge}</OurImpactTitle>
                        <TaxDeductibleText>
                             <TaxDeductibleImage><Image src={TopWards} /></TaxDeductibleImage>
                             <DeductibleText>
                             <TaxDeductibleContent>
                                {MESSAGE.taxDeductible1}
                            </TaxDeductibleContent>
                            <TaxDeductibleContent>
                             {MESSAGE.taxDeductible2}
                            </TaxDeductibleContent>
                            <TaxDeductibleContent>GreatNonprofits is committed to transparency. You can read <a href="#!" onClick={() => {typeof localStorage !=="undefined"&&localStorage.removeItem("search");navigate('/organizations/browse')}}><strong>reviews</strong></a> about us, here, learn about <a href="#!" onClick={() => navigate('/about/our-story')}><strong>GreatNonprofits&#8217; mission</strong></a>, and meet our <a href="#!" onClick={() => navigate('/about/our-supporters')}><strong>supporters</strong></a>.
                            </TaxDeductibleContent>
                            </DeductibleText>
                         </TaxDeductibleText>
                     </TaxDeductible>
             </Container>
           </ImpactNumbers>
        </>
        </>
        
    )
};
export default DonateToUs;